import styled from "styled-components";
import colors from "css/colors";

export const EnableWeightToggle = styled.div`
  padding-bottom: 5px;
  text-decoration: underline;
  color: ${colors.GREY_DARK};
  &:hover {
    color: inherit;
    cursor: pointer;
  }
`;

export const PickFeeSectionStyle = styled.div`
  .editable-cell-value-wrap {
    padding: 5px 12px;
    cursor: pointer;
  }

  .ant-editable-field > .editable-cell-value-wrap {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    background-color: white;
  }

  .ant-tabs-tab .anticon-delete {
    margin-right: 0px;
  }

  .change-needed,
  .change-needed::placeholder {
    color: red;
  }

  .ant-editable-field > .editable-cell-value-wrap.disabled,
  .ant-editable-field > .editable-cell-value-wrap.disabled::placeholder {
    background-color: #f5f5f5;
  }
`;
